import { Box, Typography } from '@mui/material'
import BackdropImage from './backdropImage/backdropImage'

type ImageBoxProps = {
  src: string
  alt: string
  label: string
}

export default function ImageBox(props: ImageBoxProps) {
  return (
    <>
      <Typography mb={2}>{props.label}</Typography>
      <Box
        border={2}
        borderRadius={1}
        borderColor={'lightgray'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <BackdropImage>
          <img src={props.src} alt={props.alt} width='100%' height='100%' />
        </BackdropImage>
      </Box>
    </>
  )
}
